import { render, staticRenderFns } from "./Gravame.vue?vue&type=template&id=1964558f&"
import script from "./Gravame.vue?vue&type=script&lang=js&"
export * from "./Gravame.vue?vue&type=script&lang=js&"
import style0 from "./Gravame.vue?vue&type=style&index=0&id=1964558f&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1964558f')) {
      api.createRecord('1964558f', component.options)
    } else {
      api.reload('1964558f', component.options)
    }
    module.hot.accept("./Gravame.vue?vue&type=template&id=1964558f&", function () {
      api.rerender('1964558f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Gravame.vue"
export default component.exports